// extracted by mini-css-extract-plugin
export var LastCommuniquesPressSlider = "LastCommuniquesPressSlider-module--LastCommuniquesPressSlider--9ca8e";
export var LastCommuniquesPressSliderBtn = "LastCommuniquesPressSlider-module--LastCommuniquesPressSliderBtn--ade3a";
export var LastCommuniquesPressSwiper = "LastCommuniquesPressSlider-module--LastCommuniquesPressSwiper--fa8c9";